export const resizeModalToScreen = () => {
  const modal = document.querySelector(".modal-content"); // Pobierz element modala
  if (modal) {
    // modal.style.width = `${window.innerWidth * 0.8}px`; // Ustaw szerokość na 80% szerokości okna
    modal.style.height = `${window.innerHeight * 0.8}px`; // Ustaw wysokość na 80% wysokości okna
  }
};
